// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';


/**
 * 获取语言
 * @param options
 */
export async function apiGetLanguages(options?: { [key: string]: any }) {
  return request<API.ApiEnvelope<API.LanguageItem[]>>('/api/languages', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 获取语言 (已启用)
 * @param options
 */
export async function apiGetLanguagesAbled(options?: { [key: string]: any }) {
  return request<API.ApiEnvelope<API.LanguageItem[]>>('/api/languages/enabled', {
    method: 'GET',
    ...(options || {}),
  });
}


/** 批量上传文件接口（保存时才调用） */
export async function apiBatchUploadOss(files: File[], options?: { [key: string]: any }) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file);
  });

  return request<API.ApiEnvelope<string[]>>('/api/oss/uploads', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  });
}
